export const PAYMENT_OPTION_UPDATED = "payment_option_updated";
export const ADDRESSES_RECEIVED = "addresses_received";
export const COUNTRIES_RECEIVED = "countries_received";
export const STATES_RECEIVED = "states_received";
export const SHIPPING_METHODS_RECEIVED = "shipping_methods_received";
export const PAYMENT_METHODS_RECEIVED = "payment_methods_received";
export const BILLING_ADDRESS_ADDED = "billing_Address_added";
export const SHIPPING_ADDRESS_ADDED = "shipping_Address_added";
export const BILLING_ADDRESS_SELECTED = "billing_Address_selected";
export const SHIPPING_ADDRESS_SELECTED = "shipping_Address_selected";
export const SHIPPING_METHOD_SELECTED = "shipping_method_selected";
export const CUSTOMER_PAYMENT_METHODS_RECEIVED = "customer_payment_methods_received";
export const PAYMENT_METHOD_SELECTED = "payment_method_selected";
export const ORDER_SUMMARY_RECEIVED = "order_summary_received";
export const ORDER_COMPLETE = "order_complete";
export const PAYMENT_FAILED = "payment_failed";
export const APPROVAL_CODE_VALIDATED = "approval_code_validated";
export const APPROVAL_CODE_FAILED = "approval_code_failed";
export const APPROVAL_CODE_RESET = "approval_code_reset";
export const LEASE_COMPLETE = "lease_complete";
export const LEASE_FAILED = "lease_failed";